// extracted by mini-css-extract-plugin
module.exports = {"loadMore":"LoadMore_loadMore___Iirj","btn":"LoadMore_btn__9WJL8","ldsDualRing":"LoadMore_ldsDualRing__bLJps","isLoading":"LoadMore_isLoading__ftAoY"};